import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { ApiService } from '../../services/api/api.service';
import { AlertError, AlertSuccess } from '../actions';
import * as actions from '../actions/packages.actions';
import { getCurrentOrganizationId$, selectAllPackages$ } from '../selectors';

@Injectable()
export class PackageEffects {
    constructor(private actions$: Actions, private _api: ApiService, private store$: Store) {}

    getPackages$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.GetPackages),
            withLatestFrom(this.store$.select(getCurrentOrganizationId$), this.store$.select(selectAllPackages$)),
            mergeMap(([_action, orgId, packages]) => {
                if (packages?.length > 0) {
                    return [];
                }
                return from(this._api.assets.getPackages()).pipe(
                    map(response => {
                        return actions.SetPackages({
                            organizationId: orgId,
                            packages: response as any,
                        });
                    }),
                    catchError(error => of(AlertError({ message: error })))
                );
            })
        )
    );

    deletePackage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.DeletePackage),
            withLatestFrom(this.store$.select(getCurrentOrganizationId$)),
            mergeMap(([action, organizationId]) => {
                return from(this._api.assets.deletePackage(action.packageId)).pipe(
                    map(response => {
                        response && this.store$.dispatch(AlertSuccess({ message: response }));
                        return actions.DeletePackageSuccess({
                            organizationId: organizationId,
                            packageId: action.packageId,
                        });
                    }),
                    catchError(error => of(AlertError({ message: error })))
                );
            })
        )
    );

    createPackage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.CreatePackage),
            mergeMap(({ organizationId, packageData }) =>
                from(this._api.assets.createPackage(packageData)).pipe(
                    map((created: any) => {
                        this.store$.dispatch(
                            AlertSuccess({ message: packageData?.id ? 'Package updated successfully.' : 'Package created successfully.' })
                        );
                        return actions.CreatePackageSuccess({ organizationId, packageData: created });
                    }),
                    catchError(error => of(AlertError({ message: error })))
                )
            )
        )
    );
}
